import React from "react";
import Button from "../button/default";
import Icon from "../icon";

export default function SymbolButton(
  {
    icon,
    href = null,
    className = "",
    disabled = false,
    attributes = {},
    onClick = null,
    ref
  }
) {
  return (
    <Button
      ref={ref}
      href={href}
      className={className}
      disabled={disabled}
      attributes={attributes}
      onClick={onClick}
    >
      <Icon name={icon} />
    </Button>
  );
};
